import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PhoneNumberWithPrefixResponse {
  @jsonMember(String)
  public readonly prefix!: string;

  @jsonMember(String)
  public readonly number!: string;
}
